import { TotalsStore } from "@/stores/totals-store.core";
import type { Breakdown } from "@laborchart-modules/lc-core-api/dist/api/totals/get-company-totals";
import { useQuery } from "@tanstack/react-query";

export function useGetCompanyTotalsBreakdownQuery(
   startDay: string,
   endDay: string,
   breakdown: Breakdown = "monthly",
) {
   return useQuery({
      queryKey: ["company-totals-breakdown", startDay, endDay, breakdown],
      queryFn: async () => {
         const response = await TotalsStore.getCompanyTotals({ startDay, endDay, breakdown })
            .payload;
         return response.data;
      },
      enabled: !!startDay && !!endDay,
      refetchOnWindowFocus: false,
   });
}
